import { defaultColors } from '../defaultStyles'

export const defaultButtonTheme = {
	label: defaultColors.white,
	focusOutline: defaultColors.accentBlue,

	background: defaultColors.brandGreen,
	backgroundTranslucent: defaultColors.brandGreenTranslucent,
	backgroundDisabled: defaultColors.gray,
	backgroundHover: defaultColors.brandGreenLight,
	backgroundError: defaultColors.accentRed,
	backgroundErrorHover: defaultColors.accentRedLight,
	backgroundSuccess: defaultColors.accentGreen,
	backgroundSuccessHover: defaultColors.accentGreenLight,

	loadingIndicator: defaultColors.brandYellow,
	loadingIndicatorBackground: defaultColors.brandGreenTranslucent,
}
